import { render, staticRenderFns } from "./ProlongEndDateDialog.vue?vue&type=template&id=6ebc89ed&scoped=true&"
import script from "./ProlongEndDateDialog.vue?vue&type=script&lang=js&"
export * from "./ProlongEndDateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebc89ed",
  null
  
)

export default component.exports